<template>
  <div class="article_container" v-show="props.index < props.btnClick">
    <div class="article_block d-flex flex-column">
      <div class="title content_line">
        <div class="item_parent">
          <div class="content_title">
            <div class="texttitle">第{{ index + 1 }}ブロック見出し</div>
          </div>
          <div class="content_item long-input">
            <input
              class="form-control"
              v-if="articles.article[props.index]"
              type="text"
              v-model="articleStore.articles.article[props.index].header"
              maxlength="100"
            />
          </div>
        </div>
      </div>
      <div class="title body_content">
        <div class="item_parent_body d-flex flex-row">
          <div class="content-title_body">
            <div class="texttitle">本文</div>
          </div>
          <div class="content_item_body" translate="no">
            <CustomQuillEditor
              :index="props.index"
              :quills="props.quills"
              :isBodyInvalid="props.isBodyInvalid"
            />
          </div>
        </div>
      </div>
      <div class="title content_line">
        <div class="item_parent">
          <div class="content_title">
            <div class="texttitle">サムネイル</div>
          </div>
          <div class="m-2 content_item d-flex flex-column">
            <div :key="someUniqueKey" v-if="image" class="item_parent image">
              <img class="preview_image" :src="image" />

              <button @click="fileDelete" class="round_btn"></button>
            </div>
            <button @click="triggerFileInput" class="submit_button">
              画像を選択
            </button>

            <span v-if="image">{{ fileName }}</span>
            <input
              type="file"
              accept="image/*"
              ref="fileInput"
              style="display: none"
              @change="handleFileChange"
            />
          </div>
        </div>
      </div>

      <div class="title content_line">
        <div class="item_parent">
          <div class="content_title">
            <div class="texttitle">キャプション</div>
          </div>
          <div class="content_item long-input">
            <input
              class="form-control"
              type="text"
              maxlength="100"
              v-model="articleStore.articles.article[props.index].explain"
            />
          </div>
        </div>
      </div>
      <div class="title content_line">
        <div class="item_parent">
          <div class="content_title">
            <div class="texttitle">レイアウト</div>
          </div>
          <div class="content_item">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="layout-left"
                :value="1"
                v-model="articleStore.articles.article[props.index].layout"
              />
              <label class="form-check-label" for="layout-left">左</label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="layout-right"
                :value="2"
                v-model="articleStore.articles.article[props.index].layout"
              />
              <label class="form-check-label" for="layout-right">右</label>
            </div>
          </div>
        </div>
      </div>
      <div class="title content_line">
        <div class="item_parent">
          <div class="content_title">
            <div class="texttitle">クレジット</div>
          </div>
          <div class="content_item long-input">
            <input
              class="form-control"
              type="text"
              maxlength="100"
              v-model="articleStore.articles.article[props.index].credit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import CustomQuillEditor from "../components/CustomQuillEditor.vue";

import { useArticleStore } from "@/store/articleStore";
import imageFunction from "@/components/image.js";

const articleStore = useArticleStore();
const fileInput = ref(null);
const fileName = ref(null);

const { getImageFromUrl } = imageFunction();
const { uploadFile } = imageFunction();

const props = defineProps({
  btnClick: Number,
  index: Number,
  quills: Object,
  isBodyInvalid: Boolean,
});

const articles = articleStore.articles;

const image = ref(null);
// fileDeleteが実行されたかをトラッキングするref
const isFileDeleted = ref(false);

watchEffect(async () => {
  if (isFileDeleted.value) return;
  if (articles.article[props.index] && articles.article[props.index].image) {
    image.value = await getImageFromUrl(articles.article[props.index].image);
  }
  articles.article[props.index].image = image.value;
  articleStore.setImage(props.index, image.value);
});

/**
 * 実際のファイル入力フィールドをトリガーする
 */
const triggerFileInput = () => {
  isFileDeleted.value = true; // fileDeleteが実行されたことをマーク
  // refを使用して非表示のファイル入力フィールドをトリガー
  fileInput.value.click();
};

const fileDelete = () => {
  isFileDeleted.value = true; // fileDeleteが実行されたことをマーク
  fileName.value = null;
  image.value = null;
  articles.article[props.index].image = null;
  articleStore.setImage(props.index, image.value);
  // fileInputのvalueをクリアする
  if (fileInput.value) {
    fileInput.value.value = "";
  }
};

const handleFileChange = async (event) => {
  try {
    await uploadFile(event, image);
    fileName.value = event.target.files[0].name;
    articles.article[props.index].image = image.value;
    articleStore.setImage(props.index, image.value);
  } catch (e) {
    return;
  }
};

defineExpose({ fileDelete });
</script>

<style scoped>
.custom-upload-button {
  padding: 10px 15px;
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.content_parent {
  min-width: 40em;
}

input[type="text"] {
  margin: 0;
  width: 100%;
}

.long-input input {
  width: 100%;
}

.body_content {
  height: auto;
  min-height: auto;
  width: 100%;
}

.item_parent_image {
  min-height: 100%;
  min-width: 100%;
}

.content_item_body {
  width: 100%;
}

/*  本文などtextareaを使う時にitem_parentと同じ場所に付与  */

.item_parent_body {
  width: 100%;
  min-height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: row;
}

.content-title_body {
  text-align: center;
  align-items: center;
  height: auto;
  min-height: 16em;
}

.article_container {
  margin: 0.5em;
  border: 1px solid #aaa;
}

.long-input {
  width: 100%;
}

.row_item_parent {
  width: 80%;
}

.article_block {
  margin: 0.4em 1em;
  min-width: 45%;
}
</style>
